import { z } from "zod";
//
// Shared
//
export const DTODocumentationMarkdownUnsupportedErrorCode = z.literal("UNSUPPORTED_CONTENT");
export const DTODocumentationMarkdownUnsupportedError = z.object({
    code: DTODocumentationMarkdownUnsupportedErrorCode,
    message: z.string(),
});
//
// Request
//
export const DTODocumentationMarkdownRequest = z.object({
    markdown: z.string(),
});
//
// Validate
//
export const DTODocumentationMarkdownValidateSuccessResponse = z.object({
    isValid: z.literal(true),
    blockCount: z.number().int().nonnegative(),
});
export const DTODocumentationMarkdownValidateFailureResponse = z.object({
    isValid: z.literal(false),
    error: DTODocumentationMarkdownUnsupportedError,
});
export const DTODocumentationMarkdownValidateResponse = z.discriminatedUnion("isValid", [
    DTODocumentationMarkdownValidateSuccessResponse,
    DTODocumentationMarkdownValidateFailureResponse,
]);
//
// Write
//
export const DTODocumentationMarkdownWriteResponse = z.object({
    pageId: z.string(),
    blockCount: z.number().int().nonnegative(),
});
